import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataTypeReportFunctions } from 'store/ducks/Reportings/types';
import { columns } from 'components/Columns/ReportFunctionsColumns';

interface reportFunctionsProps {
  entityName: string;
}

const ReportFunctions: React.FC<reportFunctionsProps> = ({ entityName }) => {
  const { date, is_additional_displayed } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeReportFunctions[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));
    const params = {
      entity_name: entityName,
      date,
    };
    try {
      const fetchedData = await reportingOp.fetchReportFunctions(params);
      if (fetchedData && Array.isArray(fetchedData.filtered_data)) {
        const date = fetchedData.date;
        const entityName = fetchedData.entity_name;

        const formattedData = fetchedData.filtered_data.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: entityName,
            alternatives_exit: dataItem.alternatives_exit,
            criticality_assessment: dataItem.criticality_assessment,
            date_of_last_assessment: dataItem.date_of_last_assessment,
            description: dataItem.description,
            dora_criticality: dataItem.dora_criticality,
            end_date: dataItem.end_date,
            function_identifier: dataItem.function_identifier,
            function_level: dataItem.function_level,
            function_name: dataItem.function_name,
            impact_of_discontinuing: dataItem.impact_of_discontinuing,
            licensed_activity: dataItem.licensed_activity,
            possibility_of_reintegration: dataItem.possibility_of_reintegration,
            reasons_for_criticality: dataItem.reasons_for_criticality,
            recovery_point_objective: dataItem.recovery_point_objective,
            recovery_time_objective: dataItem.recovery_time_objective,
            start_date: dataItem.start_date,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_additional_displayed, entityName]);

  return (
    <>
      <Table columns={columns} dataSource={data} scroll={{ x: 1000, y: 430 }} />
    </>
  );
};

export default ReportFunctions;
